import {
  IPlatformServiceMock
} from './index'

export const mockPlatformService = (): IPlatformServiceMock => ({
  getPlatformInfo: jest.fn()
})
